import { render, staticRenderFns } from "./rakan-niaga-list.vue?vue&type=template&id=1ac267ce&"
import script from "./rakan-niaga-list.vue?vue&type=script&lang=js&"
export * from "./rakan-niaga-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports